

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"10","height":"17","viewBox":"0 0 10 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M3.65863 8.50338L9.64418 2.51756C9.80899 2.35314 9.89966 2.1333 9.89966 1.89889C9.89966 1.66436 9.80899 1.44465 9.64418 1.27997L9.11969 0.75574C8.95514 0.590797 8.73518 0.5 8.50077 0.5C8.26636 0.5 8.04666 0.590797 7.88197 0.75574L0.755222 7.88237C0.589889 8.04758 0.499353 8.26832 0.500003 8.50299C0.499353 8.7387 0.589759 8.95919 0.755222 9.12452L7.87534 16.2443C8.04002 16.4092 8.25973 16.5 8.49426 16.5C8.72867 16.5 8.94838 16.4092 9.11319 16.2443L9.63755 15.72C9.97875 15.3788 9.97875 14.8234 9.63755 14.4823L3.65863 8.50338Z","fill":"#342245"}, []), "\n"]);
};

        